export const CommerceDataEsp = {
    form: {
        inputs: {
            name: {
                label: "nombre completo*",
                placeholder: "Ej. Maria torres Martínez",
            },
            company: {
                label: "nombre empresa*",
                placeholder: "Ej. Ejemplo SL",
            },
            email: {
                label: "correo electrónico*",
                placeholder: "Ej. ejemplo@gmail.com",
                error: "Formato de correo inválido*",
            },
            phone: {
                label: "teléfono*",
                placeholder: "Ej. +34 000 000 000",
                error: "Formato de teléfono inválido*",
            },
            type: {
                label: "¿qué tipo de negocio eres?*",
                type_options: [],
            },
            location: {
                label: "selecciona la ubicación de tu empresa*",
            },
        },
        button: "Enviar solicitud",
    },
    success: {
        message: "El formulario se ha enviado correctamente.",
        button: "Enviar otra solicitud",
    },
    error: {
        message: "Hubo un error al enviar la solicitud",
        button: "Volver a intentar",
    },
};
